export const READ_RECEIPT_DWELL_MS = 3000;
export const messageSortKeyOf = (message) => {
    if (message.sortKey)
        return message.sortKey;
    if (message.createdAt && message.id) {
        return `MESSAGE#${message.createdAt}#${message.id}`;
    }
    return "";
};
export const maxSortKey = (left, right) => {
    const a = String(left || "");
    const b = String(right || "");
    if (!a)
        return b || null;
    if (!b)
        return a;
    return a >= b ? a : b;
};
export const receiptStatusForOwnMessage = (message, receipts) => {
    const sortKey = messageSortKeyOf(message);
    const lastRead = String(receipts?.lastReadSortKey || "");
    const lastDelivered = String(receipts?.lastDeliveredSortKey || "");
    if (sortKey && lastRead && sortKey <= lastRead)
        return "read";
    if (sortKey && lastDelivered && sortKey <= lastDelivered)
        return "delivered";
    return "sent";
};
